import { http } from './config';

const FINANCEIRO_PATH = 'financeiro';

export default {
  atualizarFinanceiroCliente: (codigo, financeiro) =>
    http.post(`${FINANCEIRO_PATH}/${codigo}/update`, financeiro),
  getFinanceiroClienteByCodigo: (codigo, data) =>
    http.post(`${FINANCEIRO_PATH}/${codigo}`, {
      data
    }),
  atualizarFinanceiroGeral: financeiro =>
    http.post(`${FINANCEIRO_PATH}/geral/adm/update`, financeiro),
  getFinanceiroGeral: data =>
    http.post(`${FINANCEIRO_PATH}/geral/adm`, {
      data
    })
};
